import React, { Component } from "react";
import { connect } from "react-redux";
import { getDocuments, addDocument, deleteDocument } from "../les-tabs-ducks/Documents.ducks";
import { Service } from "../../../../service/service";
import { API } from "../../../../../const";
import _ from "lodash";
import moment from "moment";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import Lightbox from "lightbox-react";
import "lightbox-react/style.css";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class Documents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      titre: "",
      description: "",
      selectedFile: null,
      uploading: false,
      deletingId: null,
      isOpenPreview: false,
      previewUrl: null,
      fromArchive: window.location.pathname.includes("archives"),
    };
  }

  componentDidMount() {
    let tok = localStorage.getItem("token");
    let id = window.location.pathname.match(/\d+/g)[0];
    this.props.getDocuments(tok, id);
  }

  handleAdd = () => {
    this.setState({ showForm: true, titre: "", description: "", selectedFile: null });
  };

  handleCancel = () => {
    this.setState({ showForm: false, titre: "", description: "", selectedFile: null });
  };

  handleFileChange = (e) => {
    this.setState({ selectedFile: e.target.files[0] });
  };

  formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " o";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " Ko";
    return (bytes / (1024 * 1024)).toFixed(1) + " Mo";
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { selectedFile, titre, description } = this.state;
    if (!selectedFile || !titre.trim()) return;

    let tok = localStorage.getItem("token");
    let idEnfant = window.location.pathname.match(/\d+/g)[0];

    this.setState({ uploading: true });

    let formPayload = new FormData();
    formPayload.append("file", selectedFile);

    const uploadResponse = Service.post(
      `${API}api/creche/files?category=DOCUMENT`,
      formPayload,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    uploadResponse.then((res) => {
      const idFichier = res.data.files[0].fileId;
      this.props.addDocument(tok, idEnfant, {
        titre: titre,
        description: description,
        idFichier: idFichier,
        nomFichierOriginal: selectedFile.name,
      });
      this.setState({
        uploading: false,
        showForm: false,
        titre: "",
        description: "",
        selectedFile: null,
      });
    });
    uploadResponse.catch((err) => {
      console.error("Erreur upload document", err);
      this.setState({ uploading: false });
    });
  };

  handleDelete = (documentId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce document ?")) {
      let tok = localStorage.getItem("token");
      let idEnfant = window.location.pathname.match(/\d+/g)[0];
      this.setState({ deletingId: documentId });
      this.props.deleteDocument(tok, idEnfant, documentId);
      this.setState({ deletingId: null });
    }
  };

  handlePreview = (url) => {
    const path = url.split("?")[0].toLowerCase();
    const isImage = path.endsWith(".jpg") || path.endsWith(".jpeg") || path.endsWith(".png");
    if (isImage) {
      this.setState({ isOpenPreview: true, previewUrl: url });
    } else {
      window.open(url, "_blank");
    }
  };

  render() {
    const { documentsData, loading } = this.props;
    const { fromArchive } = this.state;
    const documents = documentsData.documents || [];
    const count = documentsData.count || 0;
    const maxDocuments = documentsData.maxDocuments || 10;
    const maxFileSizeBytes = documentsData.maxFileSizeBytes || 5242880;
    const remaining = maxDocuments - count;

    return (
      <div
        className="tab-pane show active"
        id="documents-pane"
        role="tabpanel"
        aria-labelledby="documents-tab"
      >
        <div className="content p-0">
          <section className="content-section border-0 mb-0">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h2 style={{ margin: 0 }}>Documents</h2>
                <small style={{ color: "#999" }}>
                  {count}/{maxDocuments} documents — Taille max par fichier : {this.formatFileSize(maxFileSizeBytes)}
                </small>
              </div>
              {!fromArchive && !this.state.showForm && remaining > 0 && (
                <button
                  className="btn btn-gradient"
                  onClick={this.handleAdd}
                  style={{ borderRadius: "20px", padding: "6px 20px" }}
                >
                  + Ajouter un document
                </button>
              )}
            </div>

            {this.state.showForm && (
              <div
                style={{
                  background: "#f8f9fa",
                  borderRadius: "8px",
                  padding: "20px",
                  marginBottom: "20px",
                  border: "1px solid #e0e0e0",
                }}
              >
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <label style={{ fontWeight: "600", color: "#333" }}>Titre *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.titre}
                      onChange={(e) => this.setState({ titre: e.target.value })}
                      placeholder="Titre du document"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label style={{ fontWeight: "600", color: "#333" }}>Description</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={this.state.description}
                      onChange={(e) => this.setState({ description: e.target.value })}
                      placeholder="Description du document (optionnel)"
                    />
                  </div>
                  <div className="form-group">
                    <label style={{ fontWeight: "600", color: "#333" }}>Fichier *</label>
                    <input
                      type="file"
                      className="form-control-file"
                      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                      onChange={this.handleFileChange}
                      required
                    />
                    <small style={{ color: "#999" }}>
                      Taille max : {this.formatFileSize(maxFileSizeBytes)}
                    </small>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary mr-2"
                      onClick={this.handleCancel}
                      style={{ borderRadius: "20px", padding: "6px 20px" }}
                    >
                      Annuler
                    </button>
                    <button
                      type="submit"
                      className="btn btn-gradient"
                      disabled={!this.state.titre.trim() || !this.state.selectedFile || this.state.uploading}
                      style={{ borderRadius: "20px", padding: "6px 20px" }}
                    >
                      {this.state.uploading ? "Envoi en cours..." : "Enregistrer"}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {loading ? (
              <div className="content p-0">
                <DotLoader
                  size={100}
                  color={"#ff7d26"}
                  css={override}
                  loading={true}
                />
              </div>
            ) : _.isEmpty(documents) ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px",
                  color: "#999",
                }}
              >
                <p>Aucun document pour le moment</p>
              </div>
            ) : (
              <div>
                {documents.map((doc) => (
                  <div
                    key={doc.id}
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "12px",
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-start">
                      <div style={{ flex: 1 }}>
                        <h5 style={{ marginBottom: "4px", color: "#333", fontWeight: "600" }}>
                          {doc.titre}
                        </h5>
                        <small style={{ color: "#999" }}>
                          {moment(doc.dateAjout).format("DD/MM/YYYY à HH:mm")}
                          {doc.nomFichierOriginal && (
                            <span> — {doc.nomFichierOriginal}</span>
                          )}
                        </small>
                        {doc.description && (
                          <p style={{ marginTop: "8px", marginBottom: 0, color: "#555", whiteSpace: "pre-wrap" }}>
                            {doc.description}
                          </p>
                        )}
                      </div>
                      <div className="d-flex align-items-center" style={{ marginLeft: "12px", gap: "8px" }}>
                        {doc.urlFichier && (
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => this.handlePreview(doc.urlFichier)}
                            style={{ borderRadius: "20px", padding: "4px 14px", fontSize: "13px" }}
                          >
                            <i className="fas fa-eye" style={{ marginRight: "5px" }}></i>
                            Voir
                          </button>
                        )}
                        {!fromArchive && (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => this.handleDelete(doc.id)}
                            disabled={this.state.deletingId === doc.id}
                            style={{ borderRadius: "20px", padding: "4px 14px", fontSize: "13px" }}
                          >
                            <i className="fas fa-trash" style={{ marginRight: "5px" }}></i>
                            Supprimer
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        </div>

        {this.state.isOpenPreview && this.state.previewUrl && (
          <Lightbox
            mainSrc={this.state.previewUrl}
            onCloseRequest={() => this.setState({ isOpenPreview: false, previewUrl: null })}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  documentsData: state.ficheEnfant.Documents.data,
  loading: state.ficheEnfant.Documents.loading,
});

export default connect(mapStateToProps, {
  getDocuments,
  addDocument,
  deleteDocument,
})(Documents);
